import React from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import clsx from 'clsx'

import { Text } from '@wartek-id/text-v1'

import SearchBox from 'components/SearchBox'
import { assetUrl } from 'utils/url'
import { useMediaQueryHelper } from 'app/RuangGTKHomepageV3/hooks/useMediaQueryHelper'
import { useScrollDirection } from 'app/RuangGTKHomepageV3/hooks/useScrollDirection'
import styles from '../styles.module.css'

const NAVIGATION_LINKS = [
  { label: 'Beranda', href: '/' },
  { label: 'Pemberitahuan', href: '/info-terkini' },
  { label: 'Profil', href: '/akun' },
]

const Header = () => {
  const router = useRouter()
  const { isDesktop } = useMediaQueryHelper()
  const { isScrollingDown, isAtTop } = useScrollDirection()

  // Show full header when scrolling up or at top
  const showFullHeader = !isScrollingDown || isAtTop

  return (
    <header className="sticky top-0 z-50 bg-[#2A7EFB]">
      <div
        className={clsx(
          styles['base-rgtk-homepage'],
          'mx-auto flex w-full flex-col gap-5 lg:gap-8 lg:!pt-8',
          styles['header-content']
        )}
      >
        {/* Logo and Navigation Section */}
        <div
          className={clsx(
            'flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between',
            styles['header-logo-nav'],
            showFullHeader ? styles['visible'] : styles['hidden']
          )}
        >
          <div className="flex items-center gap-4">
            <img
              src={assetUrl('/images/ruang-gtk/logo-sm-inverse.svg')}
              alt="Logo"
              className="h-8 w-auto md:h-10"
            />
            <Text
              variant={isDesktop ? 'heading-md' : 'heading-sm'}
              color="inverse"
            >
              Ruang Guru dan Tenaga Kependidikan (GTK)
            </Text>
          </div>

          <nav className="hidden items-center gap-6 text-sm font-medium text-white lg:flex xl:gap-8">
            {NAVIGATION_LINKS.map((link) => (
              <Link key={link.href} href={link.href}>
                <span className="cursor-pointer hover:opacity-80">
                  <Text variant="heading-md" color="inverse">
                    {link.label}
                  </Text>
                </span>
              </Link>
            ))}
          </nav>
        </div>

        {/* SearchBox Section */}
        <div
          className={clsx(
            'w-full',
            styles['header-searchbox'],
            showFullHeader ? styles['with-nav'] : styles['standalone']
          )}
        >
          <SearchBox
            placeholder="Cari Layanan.."
            readOnly
            onClick={() => router.push('/pencarian')}
            onClickButton={() => router.push('/pencarian')}
            className="bg-white"
          />
        </div>
      </div>
    </header>
  )
}

export default Header
